import { useEffect, useRef, useState } from 'react';
import useFixedRowActionsMenu, { ROW_ACTIONS_MENU_HEIGHT } from './useFixedRowActionsMenu';

export { ROW_ACTIONS_MENU_HEIGHT };

/** Inline ⋮ row action menu — fixed positioning so menus do not expand overflow tables. */
export function useInlineRowActions(menuHeight = ROW_ACTIONS_MENU_HEIGHT.TRIPLE) {
  const [rowActionsOpen, setRowActionsOpen] = useState({});
  const rowActionsRefs = useRef({});
  const tableScrollRef = useRef(null);
  const { layout: rowActionsMenuLayout, menuRef: rowActionsMenuRef, placementReady: rowActionsMenuPlacementReady } =
    useFixedRowActionsMenu(rowActionsOpen, rowActionsRefs, tableScrollRef, menuHeight);

  const toggleRowActions = (rowKey) => {
    setRowActionsOpen((prev) => {
      if (prev[rowKey]) return {};
      return { [rowKey]: true };
    });
  };

  const closeRowActions = () => setRowActionsOpen({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideAll = Object.values(rowActionsRefs.current).every(
        (ref) => ref && !ref.contains(event.target)
      );
      if (isOutsideAll) setRowActionsOpen({});
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return {
    rowActionsOpen,
    rowActionsRefs,
    tableScrollRef,
    rowActionsMenuLayout,
    rowActionsMenuRef,
    rowActionsMenuPlacementReady,
    toggleRowActions,
    closeRowActions,
    setRowActionsOpen,
  };
}
